import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
//requires tsconfig compiler option "resolveJsonModule": true
import VersionInfo from './assets/version.json';

// set before bootstrap so services that key local storage on the version see it immediately
window['wlVersion'] = VersionInfo.version;

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
